import React, { Component } from 'react';
import Strings from 'localization/Strings';
import { FaUserCircle } from "react-icons/fa";
import './SummaryComponent.css'

class Summary extends Component {
  constructor(props) {
    super(props);
    this.model = this.props.model;
  }

  captalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  render() {
    return (
      <div id='' className='sub-heading2'>
        <div id='summary-panel'>
          <div className='summary-list-item mantis10-bg green110'>
            <FaUserCircle className='summary-list-item-in-text-icon' />
            <span className='ms-2'>{Strings.strings.Summary.CurrentStatus}</span>
          </div>
          <div className='summary-list-item'>
            {this.model.user_selection_age} {Strings.strings.Summary.YearsOld}
          </div>
          <div className='summary-list-item'>
            {Strings.strings.getLossString(this.model.user_selection_loss)}
          </div>
          <div className='summary-list-item'>
            {Strings.strings.Summary.ClearAndNatural}: {this.model.user_selection_ssq_clarity}
          </div>
          <div className='summary-list-item'>
            {Strings.strings.Summary.Effort}: {this.model.user_selection_ssq_effort}
          </div>
          <div className='summary-list-item'>
            {Strings.strings.Summary.TelephoneConversation}: {this.model.user_selection_ssq_telephone}
          </div>
          <div className='summary-list-item'>
            {Strings.strings.Summary.OoOConversation}: {this.model.user_selection_ssq_OoO}
          </div>
        </div>
      </div>
    )
  }
}

export default Summary;